enum AuthGroup {
  None = 'none',
  Direct = 'direct-customers',
  Indirect = 'indirect-customers',
}

export default AuthGroup;
